export enum GodziDropResultType {
  None = 'None',
  RatioPrize = 'RatioPrize',
  FreeGame = 'FreeGame',
  FreeSpin = 'FreeSpin',
}
